import u from '@/utils'
import axios from 'axios'

const state = {
  honeyRoles: [],
  myHoneyRoles: [],
  privileges: []
}

const mutations = {
  setHoneyRoles(state, honeyRoles) {
    state.honeyRoles = honeyRoles
  },

  setMyHoneyRoles(state, honeyRoles) {
    state.myHoneyRoles = honeyRoles
  },

  setPrivileges(state, privileges) {
    state.privileges = privileges
  }
}

let actions = {
  async fetchHoneyRoles({ commit }) {
    let response = await axios.get('/api/v1/honeyRoles')
    let honeyRoles = [...response.data._embedded.honeyRoles]
    honeyRoles = honeyRoles.map(honeyRole => u.processResp(honeyRole))//sort by name
    honeyRoles.sort((a, b) => { return a.name.localeCompare(b.name) })
    commit('setHoneyRoles', honeyRoles)
    return honeyRoles
  },
  async fetchMyHoneyRoles({ commit }) {
    let response = await axios.get('/api/v1/honeyRoles/me')
    let honeyRoles = [...response.data._embedded.honeyRoles]
    honeyRoles = honeyRoles.map(honeyRole => u.processResp(honeyRole))
    commit('setMyHoneyRoles', honeyRoles)
    return honeyRoles
  },
  async fetchPrivileges({ commit }) {
    let response = await axios.get('/api/v1/honeyRoles/privileges')
    let privileges = response.data
    commit('setPrivileges', privileges)
    return privileges
  }
}

export default {
  state,
  actions,
  mutations
}
